import React, { FunctionComponent, useEffect } from 'react';

import { connect, ConnectedProps } from 'react-redux';

import { RootState } from '../../../init-store';
import { countMetrika } from '../../shared/helpers/metrika';
import MainScreen from './components/main-screen';

const connector = connect((state: RootState) => {
    return {
        sessionId: state.sessionId,
    };
});

type Props = ConnectedProps<typeof connector> & { autoCreate?: boolean };

const CreateCall: FunctionComponent<Props> = ({ autoCreate, sessionId }) => {
    useEffect(() => {
        countMetrika('main_screen', 'show', sessionId);
    }, [sessionId]);

    return <MainScreen autoCreate={autoCreate} />;
};

export const CreateCallPage = connector(CreateCall);
